import { render } from "./PermanentAddress.vue?vue&type=template&id=57b6b950"
import script from "./PermanentAddress.vue?vue&type=script&lang=js"
export * from "./PermanentAddress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__